import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import { Get, JENIS_DUSUN, JENIS_DESA, Post } from '../../../../function/Koneksi';

const ModalBidang = ({ data, uuidLembaga, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData }) => {
	
	const frmBidang = {
		uuid: '',
		uuid_lembaga: uuidLembaga,
		nama: '',
	}

	const initFormData = {
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [dt, setDt] = useState(data ? data : frmBidang)

	
	const changeStatus = (e) => {
		setDt({
			...dt,
			status: e.value,
		})
	};

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmBidang)

		setFormData(data ? {
			...initFormData,
		} : initFormData)
	}, [isOpen])

	const simpan = (e) => {
		e.preventDefault();
		let bodyRaw = {
			...dt,
			uuid : document.getElementById("uuid").value,
			uuid_lembaga : document.getElementById("uuid_lembaga").value,
			nama : document.getElementById("nama").value,
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyRaw.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			bodyRaw.uuid = null;
		} else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		}
			
		Post("bidang-lembaga/" + metode, bodyRaw.uuid, bodyRaw,res => {
			setFormData({
				...formData,
				status: {
					...formData.status,
					btnForm: false,
					form: false,
				}
			})
			setIsOpen(false)
			if (res.status === resstat) {
				const alertData = {
					show: true,
					basicType: "success",
					basicTitle: "Data Bidang Lembaga",
					pesanAlert: "Berhasil " + psn + " Data",
					successAlert: true,
				}
				setAlert(alertData)
			} else {
				const alertData = {
					show: true,
					basicType: "danger",
					basicTitle: "Data Bidang Lembaga",
					pesanAlert: "Gagal " + psn + " Data"
				}
				setAlert(alertData)
			}

			// Refresh list
			setStatusRefresh(true)
		});
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: '40%', maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan} 
			>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Bidang Lembaga</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<input
						className="form-control"
						id="uuid_lembaga"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid_lembaga}
					/>
					<FormGroup className="row">
						<Col sm='12'>
							<Label className="col-form-label" htmlFor="inputEmail3"><b>Nama Bidang</b></Label>
							<input className="form-control" id="nama" type="text" placeholder="Nama Bidang Lembaga" defaultValue={dt.nama} required/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status && formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalBidang;
